export const makeCollapse = props => {
    const { collapsed } = props;
    return `height: 100%;
          max-height: 100%;
          overflow: ${collapsed ? 'hidden' : 'visible'};;
          transition: all 0.3s ease-out;`;
};
export const makeCollapseToggle = () => {
    return ``;
};
export const makeCollapseContent = props => {
    const { collapsed, offset } = props;
    return `display: block;
          position: relative;
          min-height: ${offset}px;
          max-height: ${collapsed ? `${offset}px` : '100%'};
          transition: max-height .5s ease-in-out;`;
};
export const makeToggleIcon = props => {
    const { collapsed } = props;
    return `display: inline-block;
          vertical-align: -4px;
          transition: all .5s ease-in-out;
          transform: ${collapsed ? 'rotate(0deg)' : 'rotate(180deg)'};`;
};
